import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            焦点推荐
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">精选策划专题，一站发现精彩影视</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {carouselData.map((item) => (
              <a
                key={item.id}
                href={`#carousel`}
                className="group relative block rounded-2xl overflow-hidden cursor-pointer aspect-[2/1]"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  width="1200"
                  height="600"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block text-[10px] font-medium text-background-50 bg-primary-500/80 px-2.5 py-1 rounded-full mb-2">
                    {item.category}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-white/80">
                    {item.subtitle}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}